import React from 'react';

import Schwarm from './Schwarm';
import css from './SectionIntelligenz.module.css';

/**
 * FairwayBid – der Abschnitt über die Vorsortierung
 *
 * Auf der öffentlichen Startseite steht bisher, was die Plattform tut:
 * ausschreiben, Angebote sammeln, vergleichen. Was sie dabei im Hintergrund
 * rechnet, stand nirgends – und genau das unterscheidet FairwayBid von einem
 * schwarzen Brett, auf dem Anfragen hängen und zufällig jemand hinsieht.
 *
 * Dieser Abschnitt erklärt es in drei Punkten, von der Anfrage bis zum
 * Angebot, und zeigt dabei einen Schwarm im Hintergrund, der sich nach
 * denselben einfachen Regeln selbst vernetzt.
 *
 * Er steht hinter "So funktioniert FairwayBid" – erst die drei sichtbaren
 * Schritte, dann die Vertiefung für die, die weitergelesen haben. Ohne
 * Nummern, und das ist der Grund: Eine zweite 01-02-03-Reihe kurz unter der
 * ersten liest sich wie eine Dopplung, nicht wie eine Vertiefung.
 *
 * Zum Wortlaut
 * ------------
 * Was hier beschrieben wird, rechnet die Plattform tatsächlich: Anfragen
 * werden bewertet, nach Kategorie und Liefergebiet zugestellt und für jeden
 * Anbieter nach seiner Passung eingeordnet. Das sind feste, nachvollziehbare
 * Regeln - kein lernendes Modell. Deshalb steht hier "automatisch" und
 * "berechnet" und nicht "die KI erkennt": Ein Anbieter, der später merkt,
 * dass hinter dem Wort nichts steht, glaubt danach auch den Zahlen nicht
 * mehr. Kommt eines Tages ein lernendes Verfahren dazu, ist dieser Text in
 * zehn Minuten geändert.
 */

const SCHRITTE = [
  {
    titel: 'Jede Anfrage wird bewertet',
    text:
      'Noch beim Ausfüllen prüft die Plattform, ob eine Anfrage beantwortbar ist: Stückzahl, ' +
      'Budgetrahmen, Termin, Frist, gewünschte Leistungen. Die Anlage sieht ihre ' +
      'Angebotsaussicht steigen, während sie schreibt – und nicht erst, wenn die ' +
      'Ausschreibung draußen ist.',
  },
  {
    titel: 'Sie erreicht die passenden Anbieter',
    text:
      'Zugestellt wird nach Kategorie und Liefergebiet, nicht nach Gießkanne. Ein Anbieter für ' +
      'Pflegetechnik in Bayern bekommt keine Netzanlage in den Niederlanden – und die Anlage ' +
      'keine Angebote von jemandem, der gar nicht liefern kann.',
  },
  {
    titel: 'Der Anbieter sieht seine Dealchance',
    text:
      'Für jede Anfrage rechnet die Plattform gegen sein Profil: Sortiment, Liefergebiet, ' +
      'Leistungen, Klarheit der Anfrage, verbleibende Frist. Daraus entsteht eine Reihenfolge – ' +
      'er beginnt dort, wo er wirklich eine Chance hat, statt zwanzig Anfragen zu überfliegen.',
  },
];

const SectionIntelligenz = ({ sectionId }) => {
  return (
    <section className={css.rand} id={sectionId || 'fwb-intelligenz'}>
      <div className={css.tafel}>
        <Schwarm />

        <div className={css.inhalt}>
          <p className={css.eyebrow}>
            <span className={css.eyebrowPille}>KI</span>
          </p>
          <h2 className={css.ueberschrift}>
            Anfrage und Anbieter finden zueinander,
            <span className={css.zeile}> bevor jemand telefoniert.</span>
          </h2>
          <p className={css.vorspann}>
            Ausschreiben und hoffen, dass der Richtige zufällig hinsieht – so lief Beschaffung
            bisher. Bei FairwayBid erreicht Ihre Anfrage genau die Anbieter, die liefern können und
            wollen. In dem Moment, in dem Sie sie veröffentlichen.
          </p>

          <ol className={css.schritte}>
            {SCHRITTE.map(s => (
              <li key={s.titel} className={css.schritt}>
                <h3 className={css.schrittTitel}>{s.titel}</h3>
                <p className={css.schrittText}>{s.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default SectionIntelligenz;
